import {
    Button,
    Flex,
    FormControl,
    FormLabel,
    //Heading,
    Stack,
    useColorModeValue,
    FormErrorMessage,
    Box,
    Text
  } from '@chakra-ui/react'
import { useState } from "react";
import { useUserChangedPasswordMutation } from "../../slices/userApiSlice";
import { useNavigate } from 'react-router-dom';
import { ToastService } from '../../services/toast/toastService';
import { PasswordField } from '../../components/PasswordField';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"; 
import { useTranslation } from 'react-i18next';

const UserChangePassword = () => {
 
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { success, error } = ToastService();
  const navigate = useNavigate();
  const [ changedPassword, { isLoading } ] = useUserChangedPasswordMutation()
  const bgColor = useColorModeValue('teal.600', 'gray.800');
  const bgColorDark = useColorModeValue('gray.50', 'gray.700');
  const textColor = useColorModeValue('custom.900', 'gray.200');
  const formTextColor = useColorModeValue('custom.800', 'gray.200');
  const [formErrors, setFormErrors] = useState();
  const { t } = useTranslation();

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
        const payload = {
        currentPassword,
        newPassword,
        };

        await changedPassword(payload).unwrap();
        success("Password changed successfully.");
        navigate('/');

        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setFormErrors({});
    } catch(err) {
        const errorMessage = err.data?.message || 'An unexpected error occurred.';
        if (errorMessage.toLowerCase().includes("current password")) {
          setFormErrors({ currentPassword: errorMessage });
        } else {
          error(errorMessage);
        }
    }
  };

  // const cancelHandler = async (e) => {
  //   navigate('/');
  // }

  const handleCurrentPasswordChange = (e) => {
    const value = e.target.value;
    setCurrentPassword(value); // Update password state

    // Clear error message if input value changes
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      currentPassword: "",
    }));
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value); // Update password state

    // Clear error message if input value changes
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      newPassword: "",
    }));

    // Check if passwords match
    if (confirmPassword && value !== confirmPassword) {
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            confirmPassword: "Passwords do not match",
        }));
    } else {
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            confirmPassword: "",
        }));
    }
  };

  const handleConfirmPasswordChange = (e) => {
      const value = e.target.value;
      setConfirmPassword(value); // Update confirm password state

      // Clear error message if input value changes
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: "",
      }));

      // Check if passwords match
      if (newPassword && value !== newPassword) {
          setFormErrors((prevErrors) => ({
              ...prevErrors,
              confirmPassword: "Passwords do not match",
          }));
      } else {
          setFormErrors((prevErrors) => ({
              ...prevErrors,
              confirmPassword: "",
          }));
      }
  };
  
  return (
    <Flex
      minH={'100vh'}  
      direction="column"
      align="center"
      justify={'center'}      
      bg={bgColor}
      color={textColor}
      width="100%"
      // paddingTop="20px"
      pt={`calc(1rem + env(safe-area-inset-top))`}
      >
        <Box
          display="flex"
          //bg={bgColor}
          alignItems="center"
          p={2}
          mb={4}
          width="100%"
          >
          <FontAwesomeIcon
            onClick={() => navigate('/')}
            icon={faArrowLeft}
            size="xl"
            style={{ cursor: 'pointer', marginRight: '8px' }}
          />
          <Text align="left" fontSize="xl" fontWeight="bold" ml={2}>
          {t('change_password.items.change_password')}
          </Text>
        </Box>

        <Stack
          spacing={4}
          minH="100vh"
          w="full"
          maxW="lg"
          borderRadius="2xl"
          bg={bgColorDark}
          color={formTextColor}
          p={6}
        >
        <form onSubmit={submitHandler}>
        

        <FormControl isRequired isInvalid={!!formErrors?.currentPassword} mb={4}>
          <FormLabel>{t('change_password.items.current_password')}</FormLabel>
            <PasswordField showStrengthBar={false} value={currentPassword} onChange={handleCurrentPasswordChange} />
            <FormErrorMessage>{formErrors?.currentPassword}</FormErrorMessage>
        </FormControl>

        <FormControl isRequired isInvalid={!!formErrors?.newPassword} mb={4}>
          <FormLabel>{t('change_password.items.new_password')}</FormLabel>
            <PasswordField value={newPassword} onChange={handlePasswordChange} />
            <FormErrorMessage>{formErrors?.newPassword}</FormErrorMessage>
        </FormControl>

        <FormControl isRequired isInvalid={!!formErrors?.confirmPassword} mb={4}>
          <FormLabel>{t('change_password.items.confirm_password')}</FormLabel>
            <PasswordField value={confirmPassword} onChange={handleConfirmPasswordChange} />
            <FormErrorMessage>{formErrors?.confirmPassword}</FormErrorMessage>
        </FormControl>
        
        <Stack spacing={0} gap={2} direction={['column', 'row']}>
          <Button
            type="submit"
            colorScheme='teal'
            width="full" 
            mt={4}
            isLoading={isLoading}
            isDisabled={isLoading}
            >
            {t('save')}
          </Button>
          
        </Stack>
        </form>
      </Stack>
    </Flex>
  )
}

export default UserChangePassword;